import type { QueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/store/auth-store';
import { sessionScope, sessionRevision } from '@/features/auth/session-scope';

/** Hint-only reconciliation. Cancel an older read before rereading current
 * receipt data; locale/JWT rotation never changes the captured resource key. */
export async function reconcileDashboardReads(client:QueryClient,kind:'pipeline'|'channels'|'calls'|'agents'):Promise<void>{
  const owner=sessionScope(useAuthStore.getState()),revision=sessionRevision();
  if(owner==='anonymous')return;
  const filter={predicate:(query:{queryKey:readonly unknown[]})=>{
    const key=query.queryKey;
    return key[0]==='dashboard'&&key[2]===owner&&key[3]===revision&&(kind==='pipeline' ? key[1]==='pipelines'||typeof key[1]==='string'&&key[1].startsWith('pipeline:') : key[1]===kind);
  }};
  await client.cancelQueries(filter);
  if(sessionRevision()!==revision||sessionScope(useAuthStore.getState())!==owner)return;
  await client.invalidateQueries(filter);
}

/** Recovery after reconnect/visibility, including reads without provider hints. */
export function reconcileAllDashboardReads(client:QueryClient):void {
  for (const kind of ['pipeline','channels','calls','agents'] as const) void reconcileDashboardReads(client,kind);
}
